module.exports = __webpack_public_path__ + "static/header-ebc17daf3a8ce00bc6bdd9a58978fe1b.jpg";